import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import 'font-awesome/css/font-awesome.min.css';
import "./assets/style.scss";
import "./app.css";
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(

    <Provider store={store}>
      <BrowserRouter basename={"/"}>
        <App />
      </BrowserRouter>
    </Provider>
,
  document.getElementById("root")
);
